// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2e4ddd55","113":"a7d27183","121":"3dda80ed","137":"38e88628","351":"aa73c53a","432":"1ed3f4f8","787":"c875205c","920":"b18095a8"}[chunkId] + ".chunk.js";
};